import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-a41e8a88"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "next-steps-circle",
  style: {"width":"60%","height":"60%","left":"20%","top":"20%"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "subtitle" }, "Next session", -1))
const _hoisted_3 = { class: "title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import { computed, ref } from "vue";
import { TimelineMax } from "gsap";
import AbsoluteVisual from "./absolute-visual.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'next-steps-visuals',
  props: {
    sessionNumber: {}
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

const visual = ref<InstanceType<typeof AbsoluteVisual> | null>(null);

const timescale = computed(() => 1);

const fadeIn = (tl: TimelineMax): void => {
  if (!visual.value) {
    return;
  }
  tl.to(visual.value, timescale.value, { autoAlpha: 1 }, 0);
};

__expose({
  fadeIn,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AbsoluteVisual, {
    ref_key: "visual",
    ref: visual
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          (_ctx.sessionNumber == 1)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode("Solo Report")
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.sessionNumber == 2)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode("Others' views")
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.sessionNumber == 3)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createTextVNode("Viewpoints"),
                _hoisted_4,
                _createTextVNode("report")
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.sessionNumber == 4)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                _createTextVNode("Engage")
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.sessionNumber == 5)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                _createTextVNode("Develop")
              ], 64))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }, 512))
}
}

})